var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3331 10.6528V12.2586C13.3337 12.4076 13.3031 12.5552 13.2433 12.6918C13.1834 12.8284 13.0957 12.951 12.9856 13.0517C12.8755 13.1525 12.7456 13.2292 12.6041 13.277C12.4626 13.3247 12.3127 13.3425 12.1639 13.3291C10.5136 13.1501 8.92831 12.5873 7.5355 11.6858C6.23966 10.864 5.14102 9.76758 4.31759 8.47431C3.41121 7.07794 2.84714 5.48812 2.6711 3.83365C2.6577 3.68564 2.67532 3.53646 2.72286 3.39562C2.77039 3.25477 2.84678 3.12535 2.94718 3.01558C3.04757 2.90582 3.16977 2.81812 3.30599 2.75807C3.44221 2.69802 3.58946 2.66694 3.73837 2.6668H5.34732C5.6076 2.66424 5.85993 2.75623 6.05728 2.92561C6.25463 3.095 6.38353 3.33022 6.41996 3.58744C6.48787 4.10132 6.61381 4.60588 6.79538 5.0915C6.86754 5.28308 6.88315 5.49129 6.84038 5.69146C6.79761 5.89163 6.69823 6.07536 6.55404 6.22089L5.87291 6.90066C6.63639 8.2407 7.74812 9.35023 9.09082 10.1122L9.77194 9.43242C9.91776 9.28851 10.1019 9.18933 10.3024 9.14664C10.503 9.10395 10.7116 9.11954 10.9036 9.19155C11.3902 9.37276 11.8957 9.49845 12.4106 9.56623C12.6711 9.60291 12.9091 9.73388 13.0792 9.93421C13.2492 10.1346 13.3396 10.3903 13.3331 10.6528Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBot);
export default __webpack_public_path__ + "static/media/phoneBot.2deb3c6783f1f75bcaabd1c2ea22430a.svg";
export { ForwardRef as ReactComponent };